import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, tap } from 'rxjs';

import { AllowedLocalesEnum } from './locale.enum';
import { RoutesEnum } from './routes.enum';
import { LOCALE_ROUTES_CONFIG } from './locale-routes.config';
import { UserInfoResponse } from '../models/user-Info.model';
import { HttpClient } from '@angular/common/http';
import { AppService } from '../app.service';

@Injectable({
  providedIn: 'root',
})
export class LocaleService {
  // NOTE: LOCK at for now
  appLocale$ = new BehaviorSubject<AllowedLocalesEnum | null>(AllowedLocalesEnum.AT);
  userLocale$ = new BehaviorSubject<string | null>(null);

  get appLocale(): AllowedLocalesEnum | null {
    return this.appLocale$.getValue();
  }

  get rootRoute(): string {
    return '/';
  }

  get isLocaleAT(): boolean {
    return this.appLocale === AllowedLocalesEnum.AT;
  }

  get isLocaleDE(): boolean {
    return this.appLocale === AllowedLocalesEnum.DE;
  }

  private readonly allowedLockedPagesByCountry: string[] = [
    'AT',
    // 'DE',
    // 'UA'
  ];

  constructor(private http: HttpClient, private app: AppService, @Inject(PLATFORM_ID) private platformId: Object) {
  }

  getLocationInfo() {
    return this.http.get<UserInfoResponse>('/get-info/ip')
      .pipe(
        tap((data) => {
          this.userLocale$.next(data.isoCode.toLowerCase() as AllowedLocalesEnum);
        }),
      );
  }

  isAllowedByUserLocale(userLocaleIso = this.userLocale$.getValue() || 'us'): boolean {
    return this.allowedLockedPagesByCountry
      .some(countryIso => (countryIso && userLocaleIso) && countryIso.toLowerCase() === userLocaleIso.toLowerCase());
  }

  getLink(route: RoutesEnum | undefined): string {
    if (!route) { return this.appLocale ? `/${this.appLocale}` : '/'; }
    return `/${LOCALE_ROUTES_CONFIG?.[route]?.[this.app.currentLangIso]}`;
  }

  getWelcomeLink(): string {
    return `/${LOCALE_ROUTES_CONFIG?.[RoutesEnum.WELCOME]?.[this.app.currentLangIso]}`;
  }

  changeLocale(locale?: AllowedLocalesEnum): void {
    // TODO:
  }
}
